import { FormInstance } from "antd";

interface Row {
  rowKey: number;
  sign: 1 | -1;
}
// суммирующая строка секции
interface SumRow {
  sections: number[] | null; // другие секции, которые должны пересчитаться
  rows: Row[]; // строки секции, которые должны суммироваться
}

// суммирующие строки
const sumRows: Record<number, SumRow> = {
  1100: {
    sections: [1600],
    rows: [
      { rowKey: 1110, sign: 1 },
      { rowKey: 1120, sign: 1 },
      { rowKey: 1130, sign: 1 },
      { rowKey: 1140, sign: 1 },
      { rowKey: 1150, sign: 1 },
      { rowKey: 1160, sign: 1 },
      { rowKey: 1170, sign: 1 },
      { rowKey: 1180, sign: 1 },
      { rowKey: 1190, sign: 1 },
    ],
  },
  1200: {
    sections: [1600],
    rows: [
      { rowKey: 1210, sign: 1 },
      { rowKey: 1220, sign: 1 },
      { rowKey: 1230, sign: 1 },
      { rowKey: 1240, sign: 1 },
      { rowKey: 1250, sign: 1 },
      { rowKey: 1260, sign: 1 },
    ],
  },
  1600: {
    sections: null,
    rows: [
      { rowKey: 1100, sign: 1 },
      { rowKey: 1200, sign: 1 },
    ],
  },
  1300: {
    sections: [1700],
    rows: [
      { rowKey: 1310, sign: 1 },
      { rowKey: 1320, sign: 1 },
      { rowKey: 1340, sign: 1 },
      { rowKey: 1350, sign: 1 },
      { rowKey: 1360, sign: 1 },
      { rowKey: 1370, sign: 1 },
    ],
  },
  1400: {
    sections: [1700],
    rows: [
      { rowKey: 1410, sign: 1 },
      { rowKey: 1420, sign: 1 },
      { rowKey: 1430, sign: 1 },
      { rowKey: 1450, sign: 1 },
    ],
  },
  1500: {
    sections: [1700],
    rows: [
      { rowKey: 1510, sign: 1 },
      { rowKey: 1520, sign: 1 },
      { rowKey: 1530, sign: 1 },
      { rowKey: 1540, sign: 1 },
      { rowKey: 1550, sign: 1 },
    ],
  },
  1700: {
    sections: null,
    rows: [
      { rowKey: 1300, sign: 1 },
      { rowKey: 1400, sign: 1 },
      { rowKey: 1500, sign: 1 },
    ],
  },
  2100: {
    sections: [2200, 2300, 2400],
    rows: [
      { rowKey: 2110, sign: 1 },
      { rowKey: 2120, sign: -1 },
    ],
  },
  2200: {
    sections: [2300, 2400],
    rows: [
      { rowKey: 2100, sign: 1 },
      { rowKey: 2210, sign: -1 },
      { rowKey: 2220, sign: -1 },
    ],
  },
  2300: {
    sections: [2400],
    rows: [
      { rowKey: 2200, sign: 1 },
      { rowKey: 2310, sign: 1 },
      { rowKey: 2320, sign: 1 },
      { rowKey: 2330, sign: -1 },
      { rowKey: 2340, sign: 1 },
      { rowKey: 2350, sign: -1 },
    ],
  },
  2400: {
    sections: null,
    rows: [
      { rowKey: 2300, sign: 1 },
      { rowKey: 2410, sign: -1 },
      { rowKey: 2430, sign: 1 },
      { rowKey: 2450, sign: 1 },
      { rowKey: 2460, sign: 1 },
    ],
  },
};

// подсчет суммирующей строки раздела и подстановка в форму
const setSumRow = (form: FormInstance, sumRowKey: number) => {
  const sum = sumRows[sumRowKey].rows.reduce((currentSum, currentRow) => {
    // достаём значения по ключам
    const rowValue = form.getFieldValue([
      "accountingBalance",
      "data",
      currentRow.rowKey,
      "lc",
    ]);
    /* Прибавляем значение строки. 
    Если значение должно вычитаться, то приводим к модулю и вычитаем. 
    (не факт что именно так нужно, но хз как надо) */
    return currentRow.sign === 1
      ? currentSum + rowValue
      : currentSum - Math.abs(rowValue);
  }, 0);

  // подставляем сумму в форму
  form.setFieldValue(
    ["accountingBalance", "data", String(sumRowKey), "lc"],
    sum
  );
};

// пересчет всех суммирующих строк разделов, в которых пользователь вводит изменния
export const calculateSumRows = (form: FormInstance, changedRowKey: number) => {
  for (const sumRowKey in sumRows) {
    if (
      sumRows[sumRowKey].rows.some((row) => {
        return Number(row.rowKey) === Number(changedRowKey);
      })
    ) {
      setSumRow(form, Number(sumRowKey));
      sumRows[sumRowKey].sections?.forEach((sectionRowKey) => {
        setSumRow(form, Number(sectionRowKey));
      });
    }
  }
};
